<script setup lang="ts">
import Api from '@/services/api/ApiServiceFabrick';
import { DOWNLOAD_DATA_FORMATS, CSV_DATA_EXPORT_FORMATS } from '@/services/consts';
import StatusBadge from '@/components/DownloadDataHistoriesParts/StatusBadge.vue';
import getDownloadData from '@/types/responses/getDownloadData';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  item: getDownloadData;
}>();

function download() {
  const filepath = props.item.file_path;
  if (filepath) {
    Api().fileDownload(filepath);
  }
}
const accountName = computed(() => {
  return props.item.account.full_name ?? ''
});

const formatName = computed(() => {
  const format = props.item?.type;
  const allFormats = [...DOWNLOAD_DATA_FORMATS, ...CSV_DATA_EXPORT_FORMATS];
  return allFormats.find((v) => v.request_type == format)?.title;
});

const fileName = computed(() => {
  const path = props.item.file_path;
  return path?.replace(/^.*\//g, '');
});

const fileType = computed(() => {
  return 'csv'
});

</script>

<template>
  <tr>
    <td>{{ item.exit_at }}</td>
    <td><StatusBadge :status="item.status" :hasMessage="false" /></td>
    <td>{{ accountName }}</td>
    <td>{{ formatName }}</td>
    <td>{{ fileName }}</td>
    <td>{{ fileType }}</td>
    <td>
      <a
        v-if="props.item.exit_at && props.item.status == 'success'"
        href="#"
        @click.prevent.stop="download()"
      >
      {{ i18n.global.t('common.downloadBtn') }}
      </a>
    </td>
  </tr>
</template>

<style scoped></style>
